/**
 * Swap array items
 * @param array
 * @param oldIndex
 * @param adjustIndex
 * @returns {*}
 */
export default function swapArrayItems(array, oldIndex, adjustIndex) {
  if (!Array.isArray(array)
    || oldIndex + 1 > array.length
    || adjustIndex + 1 > array.length
  ) {
    return array;
  }
  [array[oldIndex], array[adjustIndex]] = [array[adjustIndex], array[oldIndex]];
  return array;
}
